import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Home() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/login', { replace: true });
      return;
    }

    navigate('/preseason-games-plans', { replace: true });
  }, [isAuthenticated, navigate]);

  // Dla zalogowanych - pokaż informację o przekierowaniu
  return (
    <div style={{
      padding: '60px 20px',
      textAlign: 'center'
    }}>
      <p style={{ fontSize: '18px', color: '#666' }}>
        Przekierowywanie...
      </p>
    </div>
  );
}

export default Home;
